import React from 'react';
import Select from "react-select";
import {useIntl} from "react-intl";
import classnames from 'classnames';
import ClearIcon from '../ClearIcon';
import {commonStyles, filtersBar} from "../../selectStyles/customSelectStyles";
import {filterOptions} from '../../../../../utils/filterOptions';
import styles from './styles.module.scss';

const FilterDropdown = ({
                          name,
                          onChangeValue,
                          options,
                          placeholder,
                          value,
                          onClearValue,
                          customContainerClassname = '',
                          customLabelClassName = '',
                          disabled
                        }) => {

  const intl = useIntl();
  const noOptionsMessage = intl.formatMessage({
    id: 'label-no-options',
    defaultMessage: 'No options',
  });

  const hasValue = Boolean(value) && value.length > 0;

  return (
    <div className={classnames(styles.container, customContainerClassname)}>
      {hasValue && <div className={classnames(styles.label, customLabelClassName)}>{placeholder}</div>}
      <Select
        name={name}
        value={filterOptions(value)(options)}
        onChange={onChangeValue}
        options={options}
        styles={{...commonStyles, filtersBar}}
        placeholder={placeholder}
        isSearchable={true}
        isAsync={true}
        defaultOptions={true}
        noOptionsMessage={() => noOptionsMessage}
        isDisabled={disabled}
      />
      <ClearIcon
        onClick={() => {
          if(!disabled) {
            onClearValue();
          }
        }}
      />
    </div>
  );
};

export default FilterDropdown;